import { render, staticRenderFns } from "./TaxPlatformContent.vue?vue&type=template&id=1c3b5ade&scoped=true"
import script from "./TaxPlatformContent.vue?vue&type=script&lang=js"
export * from "./TaxPlatformContent.vue?vue&type=script&lang=js"
import style0 from "./TaxPlatformContent.vue?vue&type=style&index=0&id=1c3b5ade&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3b5ade",
  null
  
)

export default component.exports